export const MENU_SLICE = 'MENU_SLICE';

export const IS_MENU_ITEM_HIDDEN_KEY = Symbol('isHidden');
